import { getSiteSettings } from '../selectors/sitesettings';

import { useAppSelector } from './redux';

export const useSiteSettings = () => useAppSelector(getSiteSettings);
